module.exports = __webpack_public_path__ + "img/call_reset.be8c3053.png";